<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="isLoaded">
      <v-toolbar flat color="white">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          align="center"
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- view page start here -->
        <v-dialog v-model="dialog">
          <template>
            <v-layout row>
              <v-flex xs12 sm6 md8 offset-sm2>
                <v-container fluid>
                  <!-- project information details -->
                  <project-details-info :ProjectData="editedItem" />
                  <assigned-agent-group-to-project v-if="editedItem.project_type_id === 3" :project_id=editedItem.id></assigned-agent-group-to-project>
                  <assigned-teams-to-project v-if="editedItem.dasher_category_id === 2" :project_id=editedItem.id></assigned-teams-to-project>
                  <!-- pre survey question start -->
                  <pre-survey-question-view v-if="editedItem.has_pre_survey" :pre_question="editedItem.pre_question" :baseUrl="indexData.dataStatus9.pre_image_op" :project_language="parseInt(editedItem.project_language)"/>
                  <!-- view survey question of projects -->
                  <project-question-view
                    :questionsData="editedItem.question"
                    :baseUrl="indexData.dataStatus9.image_op"
                    :project_language="parseInt(editedItem.project_language)"
                  />
                </v-container>
              </v-flex>
            </v-layout>

            <v-container fluid>
              <v-layout row>
                <div>
                  <v-btn color="red" @click="close">Cancel</v-btn>
                </div>
              </v-layout>
            </v-container>
          </template>
        </v-dialog>
        <!-- view page end here -->
      </v-toolbar>
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.dataStatus9.total < 0" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataStatus9.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="error == 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.canceled_at }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.project_type_name }}</td>
          <td>{{ props.item.begin_date }}</td>
          <td>{{ props.item.end_date }}</td>
          <td>{{ props.item.total_budget_amount }}</td>
          <td>{{ props.item.per_survey_cost }}</td>
          <td>{{ props.item.number_of_response }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataStatus9.from }} - {{ indexData.dataStatus9.to }} of {{ indexData.dataStatus9.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataStatus9.current_page"
            :length="indexData.dataStatus9.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import {
    ProjectQuestionView,
    ProjectDetailsInfo,
    PreSurveyQuestionView,
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
  } from "@/components/index";
  export default {
    components: {
      ProjectDetailsInfo,
      ProjectQuestionView,
      PreSurveyQuestionView,
      AssignedAgentGroupToProject,
      AssignedTeamsToProject,
    },
    data: () => ({
      dialog: false,
      alertMsg: false,
      // apiUrl: 'status-list/3',
      sl: 1,
      headers: [
        { text: "Project Id", align: "left", value: "id" },
        {
          text: "Project Cancelation Date",
          align: "left",
          value: "canceled_at",
        },
        { text: "Project Title", align: "left", value: "name" },
        { text: "Project Type", value: "project_type_name" },
        { text: "Project Starting Time", value: "begin_date" },
        { text: "Project Ending Time", value: "end_date" },
        { text: "Total Budget", value: "total_budget_amount" },
        { text: "Per Survey Cost", value: "per_survey_cost" },
        { text: "Total Response", value: "number_of_response" },
        { text: "Actions", value: "name", sortable: false },
      ],
      desserts: [],
      loading: false,
      search: "",
      pagination: {},
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }),

    computed: {
      ...mapGetters(["indexData", "error", "statusCode", "errorMsg"]),
      isLoaded() {
        if (this.indexData.dataStatus9) {
          return true;
        } else {
          return false;
        }
      },
      checkData() {
        if (this.editedItem) {
          if (this.editedItem.has_pre_survey) {
            return 1;
          } else {
            return 0;
          }
        }
        return 0;
      },
    },

    watch: {
      pagination() {
        this.paginationMethod();
      },
      dialog(val) {
        val || this.close();
      },
    },

    // created () {
    //   this.initialize()
    // },

    methods: {
      initialize() {
        this.paginationMethod();

        // this.alertMsg = true
        // setTimeout(() => {
        //   this.alertMsg = false
        // }, 300)
      },
      parseDataToJson(value) {
        if (value != undefined) {
          return JSON.parse(value);
        }
        return "";
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      checkItem(item) {
        if (this.indexData.dataStatus9.data) {
          this.editedIndex = this.indexData.dataStatus9.data.indexOf(item);
          this.editedItem = Object.assign({}, item);

          this.dialog = true;
        }
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      getProjectLanguage(project_language) {
        if (project_language == 1) {
          return "English";
        } else if (project_language == 2) {
          return "Bangla";
        } else {
          return "English & Bangla both";
        }
      },
      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      },
      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        this.loading = true;
        if (this.indexData.dataStatus9.data) {
          if (this.search) {
            this.$store.dispatch("changeProjectStatus", [
              "status-list",
              9,
              this.search,
              this.indexData.dataStatus9.current_page,
              this.pagination.rowsPerPage,
            ]);
            this.loading = this.indexData.dataStatus9.data ? false : true;
          } else {
            this.$store.dispatch("changeProjectStatus", [
              "status-list",
              9,
              this.search,
              this.indexData.dataStatus9.current_page,
              this.pagination.rowsPerPage,
            ]);
            this.loading = !this.indexData.dataStatus9.error ? false : true;
          }
          this.dialog = false;
        }
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
</style>
